import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'default-passive-events'
import './permission' // permission control
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.css'
import '@/assets/css/common.css'
import '@/assets/css/transition.css'
import '@/assets/js/rem.js'
import axiosInstance from '@/assets/js/axios.js'
import '../mock/mock.js'
import { responseCode } from '@/assets/js/const.js'
import '@/assets/icon/iconfont.css'

import * as filters from '@/utils/filters'
import '@/assets/js/directive.js'
Vue.prototype.$http = axiosInstance
Vue.prototype.$httpCode = responseCode
Vue.use(ElementUI)
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
